// https://github.com/iamkun/dayjs/blob/dev/docs/en/Plugin.md#localizedFormat
export const DEFAULT_DATE_FORMAT = "LL";
export const DEFAULT_DATETIME_FORMAT = "LLL";
export const FORMAT_MONTH_YEAR = "MMMM YYYY";
export const SHORT_DATE_FORMAT = "L";
export const SHORT_MONTH_DATE = "D MMM";
export const SHORT_HOUR_MINUTE = "kk:mm";
export const SHORT_DAY_MONTH_YEAR = "D MMM YYYY";
export const SHORT_MONTH_DAY_YEAR = "MMM D YYYY";
